import React, { useContext } from 'react'
import AuthContext from '../context/auth/authContext'

const Spinner = () => {
    const authContext = useContext(AuthContext);
    const { loading } = authContext;
    return (
        <>
            <div className="loader">
                <div className="spinner"></div>
            </div>
        </>
    )
}
export default Spinner;